import { LoadingPopup, LoadingPopupWrapper } from '../../components/form-components/loading-popup';

export async function showLoadingPopup(loadingPromise: Promise<any>): Promise<void> {
	const loadingPopup = new LoadingPopup(LoadingPopup.schema(), {}, {}, loadingPromise);
	loadingPopup.component.modalTitle = 'Loading';
	const popupWrapper = new LoadingPopupWrapper({}, {}, {}, loadingPopup);
	await popupWrapper.showPopup();
}
